import React, { useState, useRef, useEffect } from "react"
import { FormGroup, Label, Input, FormFeedback } from "reactstrap"

const FormikCurrencyInput = ({
  label,
  name,
  formik,
  placeholder = "$0.00",
  max = 99999999.99,
  currencySymbol = "$",
  showCharacterCounter = false,
  isLoading,
  ...props
}) => {
  const inputRef = useRef(null)
  const [rawValue, setRawValue] = useState("")

  // Sincroniza `rawValue` con el valor de Formik cuando este cambie
  useEffect(() => {
    const newValue = formik.values[name] || 0
    setRawValue(
      `${currencySymbol}${Number(newValue).toLocaleString("es-MX", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}`
    )
  }, [formik.values[name]]) // <- Se ejecuta cada vez que cambia `formik.values[name]`

  const handleChange = e => {
    const value = e.target.value

    // Eliminar caracteres no numéricos excepto punto decimal
    const numericValue = value.replace(/[^0-9.]/g, "")

    // Convertir a número flotante
    let formattedValue = parseFloat(numericValue)

    if (isNaN(formattedValue)) {
      formattedValue = 0
    }

    if (formattedValue > max) {
      formattedValue = max
    }

    // Actualizar estado local y Formik
    setRawValue(
      `${currencySymbol}${formattedValue.toLocaleString("es-MX", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}`
    )
    formik.setFieldValue(name, formattedValue)
  }

  const handleFocus = () => {
    // Al enfocar, seleccionar todo el contenido del input
    if (inputRef.current) {
      inputRef.current.select()
    }
  }

  return (
    <FormGroup>
      <Label htmlFor={name}>{label}</Label>
      {!isLoading ? (
        <>
          <Input
            type="text"
            name={name}
            id={name}
            placeholder={placeholder}
            value={rawValue}
            onChange={handleChange}
            onBlur={formik.handleBlur}
            onFocus={handleFocus}
            innerRef={inputRef}
            invalid={formik.touched[name] && !!formik.errors[name]}
            autoComplete="off"
            {...props}
          />
          {showCharacterCounter ? (
            <div className="text-end">
              {formik.values[name]?.toString().length}/{max.toString().length}
            </div>
          ) : null}
        </>
      ) : (
        <div>
          <p aria-hidden="true" className="mt-2">
            <span className="placeholder col-12 placeholder-lg placeholder-glow"></span>
          </p>
        </div>
      )}
      {formik.touched[name] && formik.errors[name] && (
        <FormFeedback>{formik.errors[name]}</FormFeedback>
      )}
    </FormGroup>
  )
}

export default FormikCurrencyInput
